var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('button',{staticClass:"absolute right-0 top-0 z-30",on:{"click":_vm.saveCroppedImage}},[_c('tick-icon',{staticClass:"text-white border border-white rounded w-8"})],1),_c('cropper',{ref:"cropper",attrs:{"src":_vm.url,"stencil-props":{
      aspectRatio: 1
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }